import { z } from 'zod';

export const UpsellType = z
  .enum([
    'hiring-copilot',
    'promotion-copilot',
    'pay-benchmarking-copilot',
    'pay-correction-copilot',
  ])
  .describe('UpsellType');

export type UpsellType = z.infer<typeof UpsellType>;

export const UpsellTypes = Object.values(UpsellType.Values);

export const HiringCopilotUpsellDefinition = z
  .object({
    type: z.literal('hiring-copilot'),
  })
  .describe('HiringCopilotUpsellDefinition');

export type HiringCopilotUpsellDefinition = z.infer<
  typeof HiringCopilotUpsellDefinition
>;

export const PromotionCopilotUpsellDefinition = z
  .object({
    type: z.literal('promotion-copilot'),
  })
  .describe('PromotionCopilotUpsellDefinition');

export type PromotionCopilotUpsellDefinition = z.infer<
  typeof PromotionCopilotUpsellDefinition
>;

export const PayBenchmarkingCopilotUpsellDefinition = z
  .object({
    type: z.literal('pay-benchmarking-copilot'),
  })
  .describe('PayBenchmarkingCopilotUpsellDefinition');

export type PayBenchmarkingCopilotUpsellDefinition = z.infer<
  typeof PayBenchmarkingCopilotUpsellDefinition
>;

export const PayCorrectionCopilotUpsellDefinition = z
  .object({
    type: z.literal('pay-correction-copilot'),
  })
  .describe('PayCorrectionCopilotUpsellDefinition');

export type PayCorrectionCopilotUpsellDefinition = z.infer<
  typeof PayCorrectionCopilotUpsellDefinition
>;

export const UpsellDefinition = z
  .union([
    HiringCopilotUpsellDefinition,
    PromotionCopilotUpsellDefinition,
    PayBenchmarkingCopilotUpsellDefinition,
    PayCorrectionCopilotUpsellDefinition,
  ])
  .describe('UpsellDefinition');

export type UpsellDefinition = z.infer<typeof UpsellDefinition>;
